import { FunctionComponent, ReactNode, useContext } from 'react'
import contextSportsHeader from '@contexts/sportsHeader'
import contextMegaModule from '@contexts/megaModule'
import { SportsHeaderContextType } from '@contexts/sportsHeader'

interface SportsHeaderContextProvider
  extends Pick<SportsHeaderContextType, 'teaserFlex' | 'teaserType'> {
  children?: ReactNode
}

const { SportsHeaderContext } = contextSportsHeader
const { MegaModuleContext } = contextMegaModule

const SportsHeaderContextProvider: FunctionComponent<
  SportsHeaderContextProvider
> = ({ teaserFlex, teaserType, children }) => {
  const megaModuleContext = useContext(MegaModuleContext)

  return (
    <SportsHeaderContext.Provider
      value={{
        teaserFlex,
        teaserType,
        isInMegaModule: !!megaModuleContext,
      }}>
      {children}
    </SportsHeaderContext.Provider>
  )
}

export default SportsHeaderContextProvider
